module.exports = __webpack_public_path__ + "img/40.470a31b.png";